import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storePotencialPoluidor, loadPotencialPoluidores } from '~/store/modules/potencial_poluidor/action';

const Create = () => {
  let history = useHistory();
  const [potencialPoluidor, setPotencialPoluidor] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ PotencialPoluidorReducer }) => PotencialPoluidorReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);


  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadPotencialPoluidores());
        }
      );
    }
  }, [status_response, history, dispatch, saved]);


  const handleClose = () => {
    history.push('/potencial_poluidor');
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(potencialPoluidor)) {
      let yup_errors = {};
      schema.validate(potencialPoluidor, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(storePotencialPoluidor(potencialPoluidor));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          PotencialPoluidor
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              potencialPoluidor={potencialPoluidor}
              handleSubmit={handleSubmit}
              schema={schema}
              setPotencialPoluidor={setPotencialPoluidor}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link className="btn btn-default" to="/potencial_poluidor">
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          form="form_potencial_poluidor"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
